// Refer-a-friend Modal JavaScript
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('refer-a-friend-modal');
    
    if (!modal) {
        return;
    }

    // Function to open the modal
    window.openReferAFriendModal = function() {
        if (modal) {
            modal.classList.add('show');
            document.body.classList.add('overflow-hidden');
            
            // Remove focus from any currently focused element
            if (document.activeElement) {
                document.activeElement.blur();
            }
            
            // Ensure the close button is focusable
            const closeBtn = modal.querySelector('.refer-a-friend-close-btn');
            if (closeBtn) {
                closeBtn.setAttribute('tabindex', '0');
            }
        }
    };

    // Function to close the modal
    window.closeReferAFriendModal = function() {
        if (modal) {
            modal.classList.remove('show');
            document.body.classList.remove('overflow-hidden');
        }
    };

    // Close modal when clicking outside of it
    modal.addEventListener('click', function(event) {
        if (event.target === modal) {
            closeReferAFriendModal();
        }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && modal.classList.contains('show')) {
            closeReferAFriendModal();
        }
        
        // Handle Tab key to focus the close button first
        if (event.key === 'Tab' && modal.classList.contains('show')) {
            const closeBtn = modal.querySelector('.refer-a-friend-close-btn');
            const shopBtn = modal.querySelector('.refer-a-friend-shop-btn');
            
            // If no element is focused or we're on the shop button tabbing forward, focus the close button
            if ((!document.activeElement || !modal.contains(document.activeElement)) || 
                (document.activeElement === shopBtn && !event.shiftKey)) {
                event.preventDefault();
                if (closeBtn) {
                    closeBtn.focus();
                }
            }
        }
    });

    // Check if modal should be shown on page load (e.g., from URL parameter)
    const urlParams = new URLSearchParams(window.location.search);
    const programId = urlParams.get('program');
    
    // Show modal if affiliate program parameter is present
    if (programId === '261778') {
        // Small delay to ensure page is fully loaded
        setTimeout(function() {
            openReferAFriendModal();
        }, 500);
    }
}); 